// extracted by mini-css-extract-plugin
export default {"tasksColumnWrapper":"TasksColumn_tasksColumnWrapper__lxuHY","taskItem":"TasksColumn_taskItem__uFwaq"};